import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useState } from "react";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { initialAndSearchStateSetter } from '../../Utility/InitialAndSearchStateSetter/InitialAndSearchStateSetter';
import { useNavigate } from 'react-router-dom';
import { mapStateToPropsForAllData } from '../../Utility/MapStateToPropsForAllData/MapStateToPropsForAllData';
import Button from '@mui/material/Button';
import { generateRandomString } from '../../Utility/GenerateRandomString/GenerateRandomString';
import { Link } from 'react-router-dom';

function Contacts({ allDataOfContact, searchedDataOfContact }) {

  const [isLoading, setIsLoading] = useState(true);
  const [contactsData, setContactsData] = useState({});
  const navigate = useNavigate();
  const { searchedKeyword } = useParams();

  useEffect(() => {

    initialAndSearchStateSetter(searchedKeyword, searchedDataOfContact, navigate, setIsLoading, setContactsData, allDataOfContact);

  }, [allDataOfContact, searchedDataOfContact, isLoading, searchedKeyword]);


  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
         <Grid container spacing={3}>
         <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', fontWeight: 'bold', marginBottom: "20px", textDecoration: "underline" }}
            >
              My Profile
            </Typography>
            { isLoading ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
      <CircularProgress />
    </Box> : ((contactsData?.data && contactsData?.data?.Contacts && contactsData?.data?.Contacts?.totalSize) != 0 ?  <Grid container>{ contactsData?.data && contactsData?.data?.Contacts?.records?.map((contactData) => {
      return <Grid container><Grid container rowSpacing={1} justifyContent="space-around" style={{ textAlign: "left" }} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      <Grid item xs={5}>
      <h5 style={{ margin: "0px" }} >Name</h5>
      <p style={{ margin: "0px", marginBottom: "16px" }} >{contactData.Name}</p>
      <h5 style={{ margin: "0px" }} >Phone</h5>
      <p style={{ margin: "0px", marginBottom: "16px" }} >{contactData.Phone}</p>
      <h5 style={{ margin: "0px" }} >Email</h5>
      <p style={{ margin: "0px", marginBottom: "16px" }} >{contactData.Email}</p>
      </Grid>
      <Grid item xs={5}>
      <h5 style={{ margin: "0px" }} >Status</h5>
      <p style={{ margin: "0px", marginBottom: "16px" }} >{contactData.Status__c}</p>
      <h5 style={{ margin: "0px" }} >Mobile</h5>
      <p style={{ margin: "0px", marginBottom: "16px" }} >{contactData.MobilePhone}</p>
      <h5 style={{ margin: "0px" }} >Account Name</h5>
      <p style={{ margin: "0px", marginBottom: "16px" }} >{contactData.Account.Name}</p>
      </Grid>
      </Grid> 
      </Grid>
    }) }
        <Grid container justifyContent="center">
            <Link to={`/ContactDetail/${generateRandomString()+"00JZ3"+contactsData?.data?.Contacts?.records[0].Id+generateRandomString()}`} style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="button"
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Edit
            </Button>
            </Link>
            </Grid>
         </Grid>
      : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>) }
        
      </Grid> 
      </Container>
 
  )
}

export default connect(mapStateToPropsForAllData)(Contacts);